<template>
  <div>
    <v-row justify="center" class="my-3">
      <v-col cols="12" lg="10" md="10" sm="12" xs="12">
        <v-card rounded class="pa-1" outlined>
          <v-row class="ma-0">
            <v-col cols="12" lg="8" md="8" sm="6" xs="12">
              <v-card-title>My papers</v-card-title>
            </v-col>
            <v-col cols="12" lg="4" md="4" sm="6" xs="12">
              <v-text-field
                id="researcher-search-input"
                v-model="search"
                outlined
                dense
                label="Search..."
                :append-icon="icon.mdiMagnify"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-divider class="mx-4"></v-divider>

          <div class="px-4">
            <v-data-table
              :headers="headers"
              :items="filteredPapers"
              :search="search"
              :loading="loading"
              loading-text="Loading papers... Wait a moment."
            >
              <template v-slot:item.track="{ item }">
                <div>{{ getTrackTitle(item.trackId) }}</div>
              </template>

              <template v-slot:item.status="{ item }">
                <div
                  :style="`color: ${getStatusColor(
                    item.state.status
                  )}; font-weight: 400`"
                >
                  {{ item.state.status }}
                </div>
              </template>

              <template v-slot:item.view="{ item }">
                <v-btn
                  icon
                  @click="sendToPaper(item.id)"
                  :id="'researcher-submission-button-' + item.id"
                >
                  <v-icon color="black"> {{ icon.mdiFileEditOutline }} </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-tooltip left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          id="researcher-new-paper-button"
          bottom
          right
          fab
          dark
          fixed
          color="#FBBD21"
          v-bind="attrs"
          v-on="on"
          @click="paperRoute"
        >
          <v-icon> {{ icon.mdiPlus }} </v-icon>
        </v-btn>
      </template>
      <span>New paper</span>
    </v-tooltip>

    <v-snackbar
      v-model="snackbar.show"
      top
      right
      :timeout="4000"
      :color="snackbar.color"
    >
      {{ snackbar.text }}
    </v-snackbar>
  </div>
</template>
 
<script>
import paperStatus from "@/helpers/paperStatus.js";
import {
  mdiPlus,
  mdiMagnify,
  mdiFileEditOutline,
  mdiCommentTextOutline,
} from "@mdi/js";

export default {
  data() {
    return {
      icon: {
        mdiPlus,
        mdiMagnify,
        mdiFileEditOutline,
        mdiCommentTextOutline,
      },
      search: "",
      headers: [
        {
          text: "Title",
          align: "start",
          sortable: true,
          value: "title",
        },
        {
          text: "Track",
          align: "center",
          sortable: true,
          value: "track",
        },
        {
          text: "Last Update",
          value: "lastUpdate",
          sortable: true,
          align: "center",
        },
        { text: "Status", value: "status", sortable: true, align: "center" },
        {
          text: "Submission",
          value: "view",
          align: "center",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    snackbar() {
      return this.$store.state.snackbar.snackbar;
    },
    papers() {
      return this.$store.getters.papers || [];
    },
    tracks() {
      return this.$store.getters.getTracks || [];
    },
    loading() {
      if (this.$store.getters.papers == null) return true;
      return false;
    },
    user() {
      return this.$store.getters.getUser;
    },
    myPapers() {
      return this.papers.filter((paper) =>
        this.user?.papersPublished?.includes(paper.id)
      );
    },
    filteredPapers() {
      return this.myPapers.filter((p) => {
        return p.title.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
  methods: {
    paperRoute() {
      this.$router.push("/dashboard/researcher/new");
    },
    getStatusColor(status) {
      return paperStatus.getStatusColor(status);
    },
    getTrackTitle(id) {
      let lang = this.$i18n.locale;
      let track = this.tracks.find((track) => track.id == id);

      return track ? track.content[lang].title : "no track";
    },
    sendToPaper(id) {
      this.$router.push(`/dashboard/researcher/${id}/edit`);
    },
  },
  async created() {
    await this.$store.dispatch("getPapers");
    await this.$store.dispatch("getTracks");
  },
};
</script>